import axios from 'axios';

const uri = '/notifications';

const state = {
  entries: [],
  fields: [
    {
      name: 'message',
      label: 'Message',
      type: 'text',
    },
    {
      name: 'type',
      label: 'Type',
      type: 'text',
    },
    {
      name: 'readAt',
      label: 'Read at',
      type: 'date',
    },
    {
      name: 'user_id',
      label: 'User',
      type: 'ref',
    },
  ],
};

// getters
const getters = {
  getFields(state) {
    return state.fields;
  },
  get(state) {
    return state.entries;
  },
};

// actions
const actions = {
  async add({ commit }, { object, callback }) {
    const { data } = await axios.post(`${uri}`, object);
    commit('add', data);

    if (typeof callback === 'function') {
      callback(data);
    }
  },
  async get({ commit }, input) {
    const { data } = await axios.get(`${uri}`);
    commit('get', data);

    if (typeof input !== 'undefined' && typeof input.callback === 'function') {
      input.callback(data);
    }
  },
  async update({ commit }, { object, callback }) {
    const { data } = await axios.put(`${uri}`, object);
    commit('set', data);

    if (typeof callback === 'function') {
      callback(data);
    }
  },
  async delete({ commit }, { id, callback }) {
    await axios.delete(`${uri}`, {
      params: {
        id,
      },
    });
    commit('delete', id);

    if (typeof callback === 'function') {
      callback();
    }
  },
};

// mutations
const mutations = {
  add(state, entry) {
    state.entries.push(entry);
  },
  get(state, data) {
    state.entries = data;
  },
  set(state, data) {
    state.entries.forEach(element => {
      if (element._id === data._id) {
        element = data;
      }
    });
  },
  delete(state, id) {
    state.entries = state.entries.filter(element => element._id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
